import { getAll } from "../utilities/querySelector";
let loadAnim;

window.addEventListener( 'beforeunload', () => {
    // Handles when event is triggered, but the page is not actually unloaded
    // e.g.  a mailto: or tel: link is clicked
    if ( ignore_onbeforeunload ) {
        ignore_onbeforeunload = false;
        return;
    };

    fadeOut();

    getAll( '.grid-line' ).forEach( line => {
        line.classList.add( 'reverse' );
    } );
} );

function fadeOut() {
    loadAnim = document.body.animate( {
        opacity: [1, 0.5]
    }, {
        duration: 600,
        fill: 'both'
    } );
}

// Handles back/forward navigation.
//Ensures if page is loaded form cache, then the page is not half opacity;
window.addEventListener( 'pageshow', ( event ) => {
    if ( event.persisted && loadAnim ) loadAnim.cancel();
} );

// Prevent mailto and tel links triggering navigation animation
let ignore_onbeforeunload = false;
getAll( 'a[href^="mailto:"], a[href^="tel:"]' ).forEach( link => link.addEventListener( 'click', function() {
    ignore_onbeforeunload = true;
} ) );